import { ReactNode } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { Global } from '@emotion/react';
import system from './system';
import fonts from './fonts';
import MontserratMedium from '../assets/fonts/Montserrat-Medium.woff';
import MontserratSemiBold from '../assets/fonts/Montserrat-SemiBold.woff';

interface ChakraProps {
  children: ReactNode;
}

function FontFaceDeclarations() {
  return (
    <Global
      styles={`
        @font-face {
          font-family: '${fonts.normal}';
          src: url(${MontserratMedium}) format('woff');
        }
        @font-face {
          font-family: '${fonts.bold}';
          src: url(${MontserratSemiBold}) format('woff');
        }
      `}
    />
  );
}

function ThemeProvider({ children }: ChakraProps) {
  return (
    <ChakraProvider value={system}>
      <FontFaceDeclarations />
      {children}
    </ChakraProvider>
  );
}

export default ThemeProvider;
